import React, { useState, useRef, useEffect } from 'react';
import { Box, Typography, Button } from '@mui/material';
import { PlayCircleOutline, StopCircle, Download } from '@mui/icons-material';
import { useDispatch, useSelector } from 'react-redux';
import { Nextstep, setQuesTopicName } from './features/counterSlice';
import { ReactMic } from 'react-mic';
import axios from 'axios';



function SpeechTest() {
  const recognitionRef = useRef(null);
  const apiData = useSelector((state) => state.questionResult.apiData);
  const TOTAL_LISTEN = apiData?.data?.Speek_Que?.Total || 0;
  const [data, setdata] = useState(apiData.data);
  const dispatch = useDispatch();
  const [record, setRecord] = useState(false);
  const [text, setText] = useState('');
  const [audioURL, setAudioUrl] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isRecording, setIsRecording] = useState(false);
  const [serverResponse, setServerResponse] = useState('');

  const mediaRecorderRef = useRef(null);
  const audioChunksRef = useRef([]);
  const audioContextRef = useRef(null);

  const [speekQueData, setSpeekQueData] = useState([]);


  // No questions found condition
  if (!data || !data.Speek_Que || TOTAL_LISTEN === 0) {
    return (
      <Box sx={{ margin: 'auto', p: 2, textAlign: 'center' }}>
        <Typography variant="h6" sx={{ color: 'red' }}>
          No question found
        </Typography>
      </Box>
    );
  }

  // Current question info
  const currentQuestion = data.Speek_Que[currentIndex];
  const description = currentQuestion.description || 'No Answer Available';

  const handleNext = () => {
    // ======================== local storage start ======================== 
    const formatData = {
      Quetion: currentQuestion?.Quetion || "",
      id: currentQuestion.id,
      selectedOption: text?.trim() || "",
      answer: currentQuestion?.Answer || 'No Answer Available',
    }
    const updatedData = [...speekQueData, formatData];
    setSpeekQueData(updatedData);
    localStorage.setItem("Speek_Que", JSON.stringify(updatedData));
    // ======================== local storage end ======================== 
    setCurrentIndex((prevIndex) => {
      if (prevIndex < TOTAL_LISTEN - 1) {
        return prevIndex + 1;
      } else {
        dispatch(Nextstep());
        return prevIndex;
      }
    });
  };

  // const startRecording = () => {
  //   setRecord(true);
  //   setText('');
  //   setAudioUrl(null);
  //   setIsRecording(true);
  // };


  // const stopRecording = () => {
  //   setRecord(false);
  //   setIsRecording(false);
  // };

  const onStop = (recordedBlob) => {
    const formData = new FormData();

    formData.append('audio_file', recordedBlob.blob, 'audio.wav');

    const url = URL.createObjectURL(recordedBlob.blob);
    setAudioUrl(url);

    axios
      .post('http://93.127.198.148:8000/audio_convert', formData)
      .then((response) => setText(response.data.text))
      .catch((err) => console.error('Upload error: ', err));
  };



  const startRecording = () => {
    setRecord(true);
    setText('');
    setAudioUrl(null);
    setIsRecording(true);
    const SpeechRecognition =
      window.SpeechRecognition || window.webkitSpeechRecognition;

    if (!SpeechRecognition) {
      alert("Your browser does not support Speech Recognition");
      return;
    }

    const recognition = new SpeechRecognition();
    recognition.lang = "en-US"; // Hindi ke liye "hi-IN"
    recognition.continuous = true;
    recognition.interimResults = false;

    recognition.onresult = (event) => {
      const transcript = event.results[event.results.length - 1][0].transcript;
      setText((prev) => prev + " " + transcript);
    };

    recognition.start();
    recognitionRef.current = recognition;
  };

  const stopRecording = () => {
    recognitionRef.current?.stop();
    setRecord(false);
    setIsRecording(false);
  };


  return (
    <Box sx={{ margin: 'auto', p: 2, textAlign: 'center' }}>

      {/* Question Section */}
      <Box sx={{ mt: 3 }}>
        <Typography
          variant="body1"
          sx={{ fontSize: '1.1rem', mb: 1, textAlign: 'left' }}
        >
          {description}
        </Typography>
        <Box sx={{ p: 2, backgroundColor: '#fff', boxShadow: 3 }}>
          <Typography
            variant="body1"
            sx={{ fontWeight: 'bold', color: '#ff02bd' }}
          >
            {currentQuestion.Quetion}
          </Typography>
        </Box>
      </Box>

      {/* Recording Section */}
      <Box sx={{ mt: 3 }}>
        <ReactMic
          record={record}
          className="sound-wave"
          onStop={onStop}
          mimeType="audio/wav"
          strokeColor="#000000"
          backgroundColor="#FF4081"
        />

        <Button
          variant="contained"
          color={isRecording ? 'error' : 'primary'}
          startIcon={isRecording ? <StopCircle /> : <PlayCircleOutline />}
          onClick={isRecording ? stopRecording : startRecording}
          sx={{ mt: 2 }}
        >
          {isRecording ? 'Stop Recording' : 'Start Recording'}
        </Button>

        {audioURL && (
          <Box
            sx={{
              mt: 2,
              display: 'flex',
              gap: 2,
              justifyContent: 'center',
              flexWrap: 'wrap',
            }}
          >
            <Button
              variant="outlined"
              color="primary"
              startIcon={<PlayCircleOutline />}
              onClick={() => new Audio(audioURL).play()}
            >
              Play Recording
            </Button>

            <Button
              variant="outlined"
              color="success"
              startIcon={<Download />}
              href={audioURL}
              download="recording.wav"
            >
              Download
            </Button>

            <Button onClick={handleNext}>
              <img
                src="/images/Picture7.png"
                alt="Next"
                style={{ width: '150px', height: 'auto' }}
              />
            </Button>
          </Box>
        )}
      </Box>

      {/* Server Response */}
      {serverResponse && (
        <Typography sx={{ mt: 2, color: 'green' }}>{serverResponse}</Typography>
      )}
    </Box>
  );
}

export default SpeechTest;
